<header class="zf-topbar">
  <nav class="zf-crumbs" aria-label="Breadcrumb">
    @for (crumb of crumbs(); track $index; let last = $last) {
      @if (!last) {
        @if (crumb.route) {
          <a [routerLink]="crumb.route" [queryParams]="crumb.queryParams">{{ crumb.label }}</a>
        } @else {
          <span>{{ crumb.label }}</span>
        }
        <span class="zf-crumb-sep">/</span>
      } @else {
        <span class="zf-crumb-current">{{ crumb.label }}</span>
      }
    }
  </nav>

  <div class="zf-topbar-right">
    @if (tenant(); as t) {
      <div class="zf-tenant-chip" [class.template]="t.isTemplate" [title]="t.isTemplate ? 'Editing an industry template' : 'Working inside a client workspace'">
        <i class="bi" [class.bi-building]="!t.isTemplate" [class.bi-layout-text-window-reverse]="t.isTemplate"></i>
        <span class="zf-tenant-kind">{{ t.isTemplate ? 'Template' : 'Workspace' }}</span>
        <span class="zf-vsep"></span>
        <span class="zf-tenant-name">{{ t.name }}</span>
        @if (t.code) {
          <span class="zf-tenant-code">{{ t.code }}</span>
        }
        <button type="button" class="zf-tenant-exit" (click)="exitTenant()" [disabled]="leaving()">
          <i class="bi bi-box-arrow-left"></i> Exit
        </button>
      </div>
    } @else if (user()?.clientName; as clientName) {
      <div class="zf-tenant-chip client" [title]="clientName">
        <i class="bi bi-building"></i>
        <span class="zf-tenant-name">{{ clientName }}</span>
        @if (user()?.clientCode; as code) {
          <span class="zf-tenant-code">{{ code }}</span>
        }
      </div>
    }
    <app-store-switcher></app-store-switcher>
    <app-user-menu></app-user-menu>
  </div>
</header>
